import React from "react";
import { Field, reduxForm, clearSubmitErrors, stopSubmit } from "redux-form";
import { Form, FormGroup, Label, Alert } from "reactstrap";

import TextInput from "../../system/fields/TextInput";
import SelectDropdown from "../../system/fields/SelectDropdown";
import FileUpload from "../../system/fields/FileUpload";
import StarRating from "../../system/fields/StarRating";

import * as validations from "../../system/utils/Validation";

let EditForm = (props, { fields }) => {
  const { handleSubmit, mode } = props;
  return (
    <section className="edit-form">
      <Form onSubmit={handleSubmit} >
        <section className="form-section container">
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Reference Name</Label>
              <Field
                name="name"
                component={TextInput}
                type="text"
                validate={validations.required}
              />
            </FormGroup>

            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Phone Number</Label>
              <Field
                name="number"
                component={TextInput}
                type="phone"
                validate={[validations.required]}
              />
            </FormGroup>
          </div>
          </section>
      </Form>

      {props.submitFailed && (

        <div className="error-container">
          <Alert color="danger">
            <strong>There are errors in your form.</strong>
            <br />Please check before submitting again.
          </Alert>
        </div>
      )}
    </section>
  );
};

EditForm = reduxForm({
  form: "ReferrerForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {dispatch(stopSubmit("ReferrerForm"))}
  }
})(EditForm);

export default EditForm;



// WEBPACK FOOTER //
// ./src/containers/Referrers/Form.jsx